/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BytesLike } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Erc20Handler } from "./Erc20Handler";

export class Erc20HandlerFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    bridgeAddress: string,
    initialResourceIDs: BytesLike[],
    initialContractAddresses: string[],
    burnableContractAddresses: string[],
    overrides?: Overrides
  ): Promise<Erc20Handler> {
    return super.deploy(
      bridgeAddress,
      initialResourceIDs,
      initialContractAddresses,
      burnableContractAddresses,
      overrides || {}
    ) as Promise<Erc20Handler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    initialResourceIDs: BytesLike[],
    initialContractAddresses: string[],
    burnableContractAddresses: string[],
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      bridgeAddress,
      initialResourceIDs,
      initialContractAddresses,
      burnableContractAddresses,
      overrides || {}
    );
  }
  attach(address: string): Erc20Handler {
    return super.attach(address) as Erc20Handler;
  }
  connect(signer: Signer): Erc20HandlerFactory {
    return super.connect(signer) as Erc20HandlerFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Erc20Handler {
    return new Contract(address, _abi, signerOrProvider) as Erc20Handler;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "initialResourceIDs",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "initialContractAddresses",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "burnableContractAddresses",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_burnList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_contractWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    name: "_depositRecords",
    outputs: [
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "_lenDestinationRecipientAddress",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_destinationChainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "_resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_destinationRecipientAddress",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_depositer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToResourceID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "fundERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "destId",
        type: "uint8",
      },
    ],
    name: "getDepositRecord",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "_tokenAddress",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "_lenDestinationRecipientAddress",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "_destinationChainID",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "_resourceID",
            type: "bytes32",
          },
          {
            internalType: "bytes",
            name: "_destinationRecipientAddress",
            type: "bytes",
          },
          {
            internalType: "address",
            name: "_depositer",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_amount",
            type: "uint256",
          },
        ],
        internalType: "struct ERC20Handler.DepositRecord",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "destinationChainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "address",
        name: "depositer",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
